import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { EnvironmentService } from '../services/environment.service';
import { getCookie } from '../utils/get-cookie.utils';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private cognitoAuth: AuthService,
    private oidcSecurityService: OidcSecurityService,
    private router: Router,
    private envService: EnvironmentService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip adding token for login/register endpoints
    const skipUrls = ['/auth/login', '/auth/register', '/auth/refresh', '/callback', this.envService.iasAuthorityUrl, this.envService.trappEndpointRootApi];
    const shouldSkip = skipUrls.some((url) => req.url.includes(url));

    if (shouldSkip) {
      return next.handle(req);
    }

    const loginOidc = localStorage.getItem('oidc-login') ?? undefined;

    return from(this.oidcSecurityService.getIdToken(loginOidc)).pipe(
      switchMap(token => {
        if (token) {
          // Clone the request and add the JWT token
          const authReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token.toString()}`,
              'Accept-Language': 'it',
            },
          });

          return next.handle(authReq);
        } else {
          console.log('No token available');
          const sessionToken = getCookie('myesse_access_token');
          if (sessionToken) {
            const authReq = req.clone({
              setHeaders: {
                Authorization: `Bearer ${sessionToken}`,
                'Accept-Language': 'it',
              },
            });
            return next.handle(authReq);
          } else {
            console.log('No session token available');
            return next.handle(req);
          }
        }
      }),
      catchError(error => {
        console.error('Error in auth interceptor:', error);

        if (error.url.includes(this.envService.apiBaseUrl) && error.status === 401) {
          this.oidcSecurityService.logoff(loginOidc).subscribe(() => {
            console.log('Logoff completed');
            localStorage.removeItem('oidc-login');
          });
        }
        return throwError(error);
      })
    );
  }
}


